// eslint-disable-next-line @nx/enforce-module-boundaries, import/no-cycle
import { customRegionNamesDict } from '@monoimin/intl';

import type { Locales } from '@monoimin/sb-types';

export const getRegionNameByCode = (locale: Locales) => {
  const regionNamesByCode = new Intl.DisplayNames([locale], {
    type: 'region',
  });
  const customNames = customRegionNamesDict[locale];
  return {
    ...regionNamesByCode,
    of(code: string) {
      try {
        if (code in customNames) {
          return customNames[code];
        }

        return regionNamesByCode.of(code);
      } catch (error) {
        return undefined;
      }
    },
  };
};

export default getRegionNameByCode;
